<template>
    <div>{{error}}</div>
</template>

<script>
    export default {
        name: "logout",
        data: () => ({error: ''}),
        created() {
            var vue = this
            this.$firebase.auth().signOut().then(function() {
               vue.$router.push({name:'home'})
            }, function(error) {
                vue.error='Ha ocudido un error'
                console.error('Sign Out Error', error);
            });
        }
    }
</script>

<style scoped>

</style>